import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../../../environments/environment';
import {
  CrmChatListParams,
  CrmChatListResponse,
  CrmRequestChat,
} from '../interfaces/crm-chat.interface';

@Injectable({ providedIn: 'root' })
export class CrmChatsService {
  constructor(private readonly http: HttpClient) {}

  list(params: CrmChatListParams): Observable<CrmChatListResponse> {
    let httpParams = new HttpParams()
      .set('scope', params.scope)
      .set('archive', params.archive)
      .set('page', String(params.page ?? 1))
      .set('limit', String(params.limit ?? 30));

    if (params.search?.trim()) {
      httpParams = httpParams.set('search', params.search.trim());
    }

    return this.http.get<CrmChatListResponse>(`${environment.apiUrl}/chat/crm/chats`, {
      params: httpParams,
    });
  }

  getChat(requestId: string, chatId?: string | null): Observable<CrmRequestChat> {
    if (chatId) {
      return this.http.get<CrmRequestChat>(`${environment.apiUrl}/chat/${chatId}`);
    }

    return this.http.get<CrmRequestChat>(
      `${environment.apiUrl}/chat/get-chat-by-request/${requestId}`
    );
  }

  markRead(chatId: string): Observable<{ markedCount: number }> {
    return this.http.post<{ markedCount: number }>(
      `${environment.apiUrl}/chat/crm/chats/${chatId}/read`,
      {}
    );
  }

  joinRequest(requestId: string, userId: string): Observable<unknown> {
    return this.http.post(`${environment.apiUrl}/requests/crm/add-manager`, {
      requestId,
      manager: userId,
    });
  }
}
